import { useRouter } from 'next/router'
import { useEffect, useRef } from 'react'
import {
  isSupportChatHandled,
  markSupportChatHandled,
  openSupportChat,
  persistReviewBridgeFromQuery,
  shouldOpenSupportChat,
} from 'src/utils/reviewBridge'

/**
 * APP/邮件带 review_flow=bad 跳进 Dashboard 时，自动打开右下角 iTalks 客服。
 * 对接示例：?review_flow=bad&review_source=android_popup
 */
const useReviewSupportChat = () => {
  const { query, isReady } = useRouter()
  const handledRef = useRef(false)

  useEffect(() => {
    if (!isReady || handledRef.current || isSupportChatHandled()) return

    persistReviewBridgeFromQuery(query)

    if (!shouldOpenSupportChat(query)) return

    handledRef.current = true

    openSupportChat().then(opened => {
      if (opened) {
        markSupportChatHandled()
      } else {
        handledRef.current = false
      }
    })
  }, [isReady, query])
}

export default useReviewSupportChat
